import { getAuthHeaders, getBaseUrl } from './apiClient';

export type LearningPlanRecord = {
  user_email: string;
  plan_id: string;
  status: 'accepted' | string;
  created_at?: string;
  accepted_at?: string;
  updated_at?: string;
  title?: string;
  plan: any;
  source?: any;
};

export const learningPlansService = {
  accept: async (plan: any, extra?: { plan_id?: string; source?: Record<string, any> }): Promise<LearningPlanRecord> => {
    const baseUrl = getBaseUrl();
    const headers = await getAuthHeaders();
    const resp = await fetch(`${baseUrl}/secure/learning-plans`, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        plan,
        plan_id: extra?.plan_id,
        source: extra?.source,
      }),
    });
    const raw = await resp.text().catch(() => '');
    let data: any = {};
    try { data = raw ? JSON.parse(raw) : {}; } catch { data = {}; }
    if (!resp.ok) {
      throw new Error(data?.error || raw || `Failed to accept learning plan (${resp.status})`);
    }
    if (!data?.plan_id) {
      throw new Error('Learning plan accept returned no plan_id');
    }
    return data as LearningPlanRecord;
  },

  get: async (planId: string): Promise<LearningPlanRecord> => {
    const baseUrl = getBaseUrl();
    const headers = await getAuthHeaders();
    const resp = await fetch(`${baseUrl}/secure/learning-plans/${encodeURIComponent(planId)}`, {
      method: 'GET',
      headers,
    });
    const raw = await resp.text().catch(() => '');
    let data: any = {};
    try { data = raw ? JSON.parse(raw) : {}; } catch { data = {}; }
    if (!resp.ok) {
      throw new Error(data?.error || raw || `Failed to fetch learning plan (${resp.status})`);
    }
    return data as LearningPlanRecord;
  },

  list: async (options?: { limit?: number }): Promise<{ items: LearningPlanRecord[]; count: number; last_evaluated_key?: any }> => {
    const baseUrl = getBaseUrl();
    const headers = await getAuthHeaders();
    const qs = options?.limit ? `?limit=${encodeURIComponent(String(options.limit))}` : '';
    const resp = await fetch(`${baseUrl}/secure/learning-plans${qs}`, {
      method: 'GET',
      headers,
    });
    const raw = await resp.text().catch(() => '');
    let data: any = {};
    try { data = raw ? JSON.parse(raw) : {}; } catch { data = {}; }
    if (!resp.ok) {
      throw new Error(data?.error || raw || `Failed to list learning plans (${resp.status})`);
    }
    return data as { items: LearningPlanRecord[]; count: number; last_evaluated_key?: any };
  },
};


